export const formatNumber = (number) => {
  let number1 =parseInt(number);
  return number1?.toLocaleString(); // Formats number with thousand separators
};